let runtimeEnabled = false

export function setCookieAuthEnabled(enabled: boolean): void {
  runtimeEnabled = enabled
}

export function isCookieAuthEnabled(): boolean {
  return runtimeEnabled
}

export function getCookieAuthOverride(): boolean | null {
  const override = localStorage.getItem("use_cookie_auth")
  if (override === "true") {
    return true
  }
  return override === "false" ? false : null
}
